<div
  id="error"
  fxLayout="column"
  fxLayoutAlign="center center"
  style="background-color: #ce2423">
  <div class="content" fxLayout="column" fxLayoutAlign="center center">
    <!-- Left Side: Image -->
    <img
      src="assets/images/maintenance/excavator_ent.png"
      alt="Error Image"
      class="error-image" />

    <!-- Right Side: Error Message and Links -->
    <div
      class="error-content"
      fxLayout="column"
      fxLayoutAlign="center center"
      style="margin-left: 20px">
      <div
        class="message"
        style="width: 80vw; font-size: 30px"
        [innerHTML]="'ERROR.BROWSER.MAINTENANCE.DESCRIPTION' | translate"></div>
      @if (user === null) {
        <a class="back-link" [routerLink]="'/login'">
          {{ 'ERROR.BROWSER.REDIRECT' | translate }}
        </a>
      }
      @if (user) {
        <a
          id="back-link-maintenance"
          class="back-link"
          [routerLink]="'/dashboard'">
          {{ 'ERROR.BROWSER.REDIRECT' | translate }}
        </a>
      }
    </div>
  </div>
</div>
